import { __decorate } from "tslib";
import { attr } from "@ni/fast-element";
import { FoundationElement } from "../foundation-element/foundation-element.js";
/**
 * A Tab Component to be used with {@link @ni/fast-foundation#(Tabs:class)}
 *
 * @slot - The default slot for the tab content
 *
 * @public
 */
export class Tab extends FoundationElement {
}
__decorate([
    attr({ mode: "boolean" })
], Tab.prototype, "disabled", void 0);
